var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParques2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70.141,
    viewBox: "0 0 70 70.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff8f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parques_white",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    className: "cls-1",
    d: "M496.7,304.8a11.568,11.568,0,0,0-13.656-14.46A13.126,13.126,0,1,0,459.4,301.171a1.37,1.37,0,0,0,2.307-1.469,10.39,10.39,0,1,1,19-7.407A1.37,1.37,0,0,0,482.3,293.4a1.254,1.254,0,0,0,.23-.063,8.827,8.827,0,0,1,11.234,11.613,1.37,1.37,0,0,0,.7,1.76,10.425,10.425,0,0,1,6.081,9.453,11.256,11.256,0,0,1-.9,4.247,10.672,10.672,0,0,1-1.267,2.1,1.37,1.37,0,0,0,2.136,1.708,13.429,13.429,0,0,0,1.644-2.729,13.91,13.91,0,0,0,1.123-5.333A13.167,13.167,0,0,0,496.7,304.8Z",
    transform: "translate(-433.269 -281.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    className: "cls-1",
    d: "M603.972,434.614v-18h1.265a1.37,1.37,0,0,0,0-2.74h-6.829a12.7,12.7,0,0,0-9.031,3.74l-3.577,3.577v-12.4l3.941-3.939a1.37,1.37,0,0,0-1.934-1.934l-2.007,2v-7.77a1.37,1.37,0,1,0-2.74,0V424.5a1.37,1.37,0,0,0,2.329.966l5.911-5.91a10.046,10.046,0,0,1,1.362-1.14v16.214a4.1,4.1,0,0,0,.293,8.192H603.9a4.1,4.1,0,0,0,.068-8.2Zm-8.565-17.548a10.121,10.121,0,0,1,3-.455h2.83v18h-5.831Zm8.494,23.015H592.965a1.37,1.37,0,0,1,0-2.74H603.9a1.37,1.37,0,0,1,0,2.74Z",
    transform: "translate(-541.754 -380.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    className: "cls-1",
    d: "M299.576,504.745a1.37,1.37,0,0,0-1.882.46h0l-.015.025a1.37,1.37,0,0,0,2.34,1.415l.015-.025A1.37,1.37,0,0,0,299.576,504.745Z",
    transform: "translate(-295.333 -473.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    className: "cls-1",
    d: "M334.02,447.457H325.59v-15.48l4.689-4.689a1.371,1.371,0,0,0-1.815-2.055,1.235,1.235,0,0,0-.119.119l-5.092,5.095a1.37,1.37,0,0,0-.4.967v16.044h-2v-26.38a1.37,1.37,0,0,0-.6-1.135l-4.054-2.726a11,11,0,0,0-.23-1.608h3.518a1.37,1.37,0,0,0,1.37-1.37V397.15a1.37,1.37,0,0,0-2.74,0v15.723h-3.151a10.982,10.982,0,0,0-8.679-5.82,7.581,7.581,0,1,0-14.724-.959,11.408,11.408,0,0,0-3.056,1.03,1.37,1.37,0,0,0,1.233,2.443,8.649,8.649,0,0,1,3.636-.923,1.37,1.37,0,0,0,1.211-1.907,4.847,4.847,0,1,1,8.387.918,1.37,1.37,0,0,0,1.275,2.156,8.2,8.2,0,0,1,9.179,7.1,8.532,8.532,0,0,1,.066,1.058h0a8.149,8.149,0,0,1-2.548,5.946,1.37,1.37,0,0,0-.178,1.77,6.828,6.828,0,1,1-11.172,7.854v-2.6l3.458-3.456,3.288,1.8a1.37,1.37,0,1,0,1.473-2.31,1.53,1.53,0,0,0-.162-.089l-2.6-1.418,1.33-1.33a1.37,1.37,0,0,0-1.933-1.934l-2.6,2.6h0l-2.259,2.26V415.2a1.37,1.37,0,1,0-2.74,0v5.22l-4.343-4.346a1.37,1.37,0,1,0-2.043,1.826,1,1,0,0,0,.108.108l6.135,6.135a1.156,1.156,0,0,0,.147.125v6.11h0v2.548c-.008.014-.019.026-.026.04a6.7,6.7,0,1,1-10.2-8.344,1.37,1.37,0,0,0,.189-1.886,8.609,8.609,0,0,1-1.867-5.387,1.37,1.37,0,1,0-2.74,0,11.319,11.319,0,0,0,1.747,6.072,9.429,9.429,0,0,0,12.905,13.663v10.377h-6.562a1.37,1.37,0,0,0,0,2.74H334.02a1.37,1.37,0,0,0,0-2.74Zm-15.9,0h-18.53v-10.1A9.562,9.562,0,0,0,313.6,425.082a10.805,10.805,0,0,0,2.369-4.726l2.152,1.449Z",
    transform: "translate(-281.543 -380.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    className: "cls-1",
    d: "M502.622,318.245a8.031,8.031,0,0,0-8.022,8.021,1.37,1.37,0,1,0,2.74,0,5.292,5.292,0,0,1,5.287-5.287,1.37,1.37,0,0,0,0-2.74Z",
    transform: "translate(-465.412 -313.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    className: "cls-1",
    d: "M654.82,387.48a1.37,1.37,0,0,0,0,2.74,3.288,3.288,0,0,1,3.288,3.288,1.37,1.37,0,0,0,2.74,0A6.028,6.028,0,0,0,654.82,387.48Z",
    transform: "translate(-602.5 -372.894)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParques2);
export default __webpack_public_path__ + "static/media/Parques2.89905455dc39d0a0e77408732c649b87.svg";
export { ForwardRef as ReactComponent };